import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import axios from "axios";
const TimezoneSelect = ({ disabled = false, allowClear = true, value, placeholder = "Select a timezone", style, onChange }) => {
    const [timezoneOptions, setTimezoneOptions] = useState([]);
    useEffect(() => {
        loadTimezones();
    }, []);
    const loadTimezones = () => {
        axios.get('/admin/v1/timezones').then(response => {
            const timezones = response.data;
            const options = timezones.map(timezone => {
                return {
                    label: timezone.name,
                    value: timezone.name
                };
            });
            setTimezoneOptions(options);
        });
    };
    return (_jsx(Select, { disabled: disabled, allowClear: allowClear, placeholder: placeholder, style: style, onChange: onChange, value: value, showSearch: {
            optionFilterProp: ['label']
        }, options: timezoneOptions }));
};
export default TimezoneSelect;
